import React from "react";
import { FormGroup, Input, ListGroup, ListGroupItem } from "reactstrap";
import {ReactComponent as Activeswitch} from '../../../../images/activeswitch.svg';
import { ReactComponent as Inactiveswitch} from '../../../../images/inactiveswitch.svg'
import { click } from "@testing-library/user-event/dist/click";
export interface PriceLayoutProps {
  paymentList: any;
  getPaymentDetails:any
  type:String
}

const PaymentList: React.FC<PriceLayoutProps> = (props: any, ref: any) => {

  return (
    <div>
      <div className="container-subheader">{props.paymentList?.[0]?.category}</div>
      <ListGroup flush>
        {props.paymentList?.[0]?.items.map((paymentItem: any) => (
          <ListGroupItem   className={`product-list ${paymentItem.clicked?'selectedItem':'deSelctedItems'} ${paymentItem.isActive?'activeItem':'inActiveItem'}`} onClick={()=>props.getPaymentDetails(paymentItem.id)}>
              <div className="product-name">{paymentItem.name}</div>
              <div className="inActive-toggle">
              {props.type==='custom'?<div className="toggle-switch"> 
        
                <div className={`${paymentItem.isActive?'toggle-active':'toggle-Inactive'}`}>
                  {paymentItem.isActive?'Active':'InActive'}</div>            
                <div>                  
                {/* onClick={(event:any)=>{event.stopPropagation()}} */}
                  {/* <FormGroup switch>
                    <Input
                      type="switch"
                      checked={paymentItem.isActive}
                      onClick={(event:any) => {
                        //event.preventDefault();
                        //event.stopPropagation();
                        paymentItem.isActive = !paymentItem.isActive
                        
                      }}
                    />
                  </FormGroup> */}
                  <div onClick= {() => paymentItem.isActive = !paymentItem.isActive}>{paymentItem.isActive? <Activeswitch  className="CombinedShape" />:<Inactiveswitch className="CombinedShape" /> }</div>            
                </div>
                
              </div>:<></>}
              <div className= {`triangle-right ${paymentItem.clicked?'triangle-activeItem':''}`}></div></div>
          </ListGroupItem>
        ))}
      </ListGroup>
    </div>
  );
};

export default PaymentList;
